// import CountUp from "react-countup";
import { Link, useLocation } from "react-router-dom";
import { convertMultipleNewlinesToBR } from "../exports/functions";
import { marked } from "marked";
// import VisibilitySensor from "react-visibility-sensor";

const AboutThree = (props) => {
  let { pathname } = useLocation();
  const { aboutData, page } = props;
  const rawDescription = aboutData[0]?.description || "";
  const description = convertMultipleNewlinesToBR(rawDescription);

  return (
    <>
      <section
        className={`about-three py-120 position-relative z-1 overflow-hidden`}
      >
        <div className="position-relative">
          <div className="container">
            <div className="row gy-xl-0 gy-5 flex-wrap-reverse align-items-top">
              <div className="col-xl-6">
                <div className="about-three-thumbs position-relative me-xxl-3">
                  <div className="row gy-4">
                    <div className="col-sm-12">
                      <img
                        src={
                          page === "home"
                            ? aboutData[0]?.primary_image[0]?.media?.url &&
                              `${process.env.REACT_APP_cmsUrl}${aboutData[0]?.primary_image[0]?.media?.url}`
                            : aboutData[0]?.about_page_image[0]?.media?.url &&
                              `${process.env.REACT_APP_cmsUrl}${aboutData[0]?.about_page_image[0]?.media?.url}`
                        }
                        alt=""
                        className="about-three-thumbs__one w-100"
                        data-tilt=""
                        data-tilt-max={16}
                        data-tilt-speed={500}
                        data-tilt-perspective={5000}
                        style={{ paddingBottom: "unset" }}
                      />
                    </div>
                    {/* <div
                      className={`${mobile || tab ? "col-sm-4" : "col-sm-8"}`}
                      style={{
                        marginBottom: mobile || tab ? "unset" : "100px",
                      }}
                    > */}
                    {/* <div
                        className="bg-main-three-600 rounded-16 text-center py-24 px-2 mb-24"
                        data-tilt=""
                        data-tilt-max={10}
                        data-tilt-speed={500}
                        data-tilt-perspective={5000}
                        data-tilt-transition="1s"
                        data-tilt-full-page-listening=""
                      >
                        <VisibilitySensor
                          partialVisibility
                          offset={{ bottom: 200 }}
                        >
                          {({ isVisible }) => (
                            <h2 className="mb-16 text-white counter">
                              {isVisible ? (
                                <CountUp
                                  end={aboutData[0]?.attributes?.Total_Students}
                                />
                              ) : null}
                              K
                            </h2>
                          )}
                        </VisibilitySensor>
                        <span className="text-white">
                          {aboutData[0]?.attributes?.Tile_Title}
                        </span>
                        <div className="enrolled-students style-two mt-12">
                          {aboutData[0]?.attributes?.Students_Images?.data?.map(
                            (image) => (
                              <img
                                src={`${process.env.REACT_APP_strapiUrl}${image?.attributes?.url}`}
                                alt=""
                                className="w-32 h-32 rounded-circle object-fit-cove transition-2"
                              />
                            )
                          )}
                        </div>
                      </div> */}
                    {/* <img
                        src={
                          aboutData[0]?.secondary_image[0]?.media?.url &&
                          `${process.env.REACT_APP_cmsUrl}${aboutData[0]?.secondary_image[0]?.media?.url}`
                        }
                        alt=""
                        className="about-three-thumbs__two rounded-16 w-100"
                        data-tilt=""
                        data-tilt-max={10}
                        data-tilt-speed={500}
                        data-tilt-perspective={5000}
                        data-tilt-full-page-listening=""
                      /> */}
                    {/* </div> */}
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="about-three-content">
                  <div className="mb-40" id="about">
                    <div className="flex-align d-inline-flex gap-8 mb-16 wow bounceInDown">
                      <span className="text-main-600 text-2xl d-flex">
                        <i className="ph-bold ph-book-open" />
                      </span>
                      <h5 className="text-main-600 mb-0">
                        {aboutData[0]?.snippet}
                      </h5>
                    </div>
                    <h2 className="mb-24 wow bounceInRight">
                      {aboutData[0]?.title}
                    </h2>
                    <p
                      className="text-neutral-500 text-line-2 wow bounceInUp"
                      dangerouslySetInnerHTML={{
                        __html: marked(description),
                      }}
                    ></p>
                  </div>
                  <div className="grid-cols-2">
                    <div
                      className="flex-align align-items-start gap-20 animation-item"
                      data-aos="fade-up"
                      data-aos-duration={600}
                    >
                      <span className="flex-shrink-0 w-60 h-60 flex-center d-inline-flex bg-white text-main-600 text-40 rounded-16 box-shadow-md">
                        <img
                          src="assets/images/icons/specialist-icon6.png"
                          className="animate__swing"
                          alt="onsite1"
                          style={{ height: "24px", width: "24px" }}
                        />
                      </span>
                      <div className="flex-grow-1">
                        <h6 className="text-neutral-800 text-xl fw-medium custom-margin-unset">
                          {aboutData[0]?.onsite_1}
                        </h6>
                        {/* <div className="flex-align gap-8 text-neutral-500">
                          <i className="d-flex text-lg ph-bold ph-clock" />
                          Onsite
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="flex-align align-items-start gap-20 animation-item"
                      data-aos="fade-up"
                      data-aos-duration={800}
                    >
                      <span className="flex-shrink-0 w-60 h-60 flex-center d-inline-flex bg-white text-main-600 text-40 rounded-16 box-shadow-md">
                        <img
                          src="assets/images/icons/specialist-icon7.png"
                          className="animate__swing"
                          alt="onsite2"
                          style={{ height: "24px", width: "24px" }}
                        />
                      </span>
                      <div className="flex-grow-1">
                        <h6 className="text-neutral-800 text-xl fw-medium custom-margin-unset">
                          {aboutData[0]?.onsite_2}
                        </h6>
                        {/* <div className="flex-align gap-8 text-neutral-500">
                          <i className="d-flex text-lg ph-bold ph-clock" />
                          Onsite
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="flex-align align-items-start gap-20 animation-item"
                      data-aos="fade-up"
                      data-aos-duration={1000}
                    >
                      <span className="flex-shrink-0 w-60 h-60 flex-center d-inline-flex bg-white text-main-600 text-40 rounded-16 box-shadow-md">
                        <img
                          src="assets/images/icons/specialist-icon9.png"
                          className="animate__swing"
                          alt="onsite3"
                          style={{ height: "24px", width: "24px" }}
                        />
                      </span>
                      <div className="flex-grow-1">
                        <h6 className="text-neutral-800 text-xl fw-medium custom-margin-unset">
                          {aboutData[0]?.onsite_3}
                        </h6>
                        {/* <div className="flex-align gap-8 text-neutral-500">
                          <i className="d-flex text-lg ph-bold ph-clock" />
                          Onsite
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="flex-align align-items-start gap-20 animation-item"
                      data-aos="fade-up"
                      data-aos-duration={1200}
                    >
                      <span className="flex-shrink-0 w-60 h-60 flex-center d-inline-flex bg-white text-main-600 text-40 rounded-16 box-shadow-md">
                        <img
                          src="assets/images/icons/specialist-icon12.png"
                          className="animate__swing"
                          alt="onsite4"
                          style={{ height: "24px", width: "24px" }}
                        />
                      </span>
                      <div className="flex-grow-1">
                        <h6 className="text-neutral-800 text-xl fw-medium custom-margin-unset">
                          {aboutData[0]?.onsite_4}
                        </h6>
                        {/* <div className="flex-align gap-8 text-neutral-500">
                          <i className="d-flex text-lg ph-bold ph-clock" />
                          Onsite
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="flex-align align-items-start gap-20 animation-item"
                      data-aos="fade-up"
                      data-aos-duration={1400}
                    >
                      <span className="flex-shrink-0 w-60 h-60 flex-center d-inline-flex bg-white text-main-600 text-40 rounded-16 box-shadow-md">
                        <img
                          src="assets/images/icons/specialist-icon3.png"
                          className="animate__swing"
                          alt="onsite5"
                          style={{ height: "24px", width: "24px" }}
                        />
                      </span>
                      <div className="flex-grow-1">
                        <h6 className="text-neutral-800 text-xl fw-medium custom-margin-unset">
                          {aboutData[0]?.onsite_5}
                        </h6>
                        {/* <div className="flex-align gap-8 text-neutral-500">
                          <i className="d-flex text-lg ph-bold ph-clock" />
                          Onsite
                        </div> */}
                      </div>
                    </div>
                  </div>
                  {pathname !== "/ega" && (
                    <div className="pt-40 border-top border-neutral-50 mt-40 border-dashed border-0">
                      <Link
                        to="/ega"
                        className="btn btn-main rounded-pill flex-align d-inline-flex gap-8"
                      >
                        Read More
                        <i className="ph-bold ph-arrow-up-right d-flex text-lg" />
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutThree;
